import { Box, Stack, Typography } from '@mui/material';
import { MprcSimpleDialog } from 'components/MprcSimpleDialog';
import { UserOperationResults } from 'generated/CoreApi_v1';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface IProps {
    results: UserOperationResults;
    onClose: () => void;
}

export const OperationResultsDialog: React.FC<IProps> = ({ onClose, results }) => {
    const { t } = useTranslation("lms");
    return (
        <MprcSimpleDialog
            width='sm'
            title={"Resultados"}
            onClose={onClose}
            message={
                <Stack>
                    {results.totalSuccess != null && results.totalSuccess > 0 &&
                        <Box marginTop={3}>
                            <Typography variant="h4" color="success.main">{t("Enrollment.StepResult.SuccessSubtitle")}</Typography>
                            <Typography variant="body1" color="muted.main" marginLeft={4}>-&nbsp;
                                <Trans
                                    i18nKey="Enrollment.StepResult.TotalSuccessMessage"
                                    values={{ count: results.totalSuccess }}
                                    t={t}
                                />
                            </Typography>
                        </Box>
                    }
                    {results.totalFail != null && results.totalFail > 0 &&
                        <Box marginTop={3}>
                            <Typography variant="h4" color="error.main">{t("Enrollment.StepResult.ErrorSubtitle")}</Typography>
                            <Stack direction="column">
                                {results.usersFail?.map(item => (
                                    <Typography variant="body1" color="muted.main" component="span">-&nbsp;<strong>{item.name}: </strong>{item.message}</Typography>
                                ))}
                            </Stack>
                        </Box>
                    }
                </Stack>
            }
        />
    );
};
